import { createTheme } from '@mui/material/styles'

const DarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#002FAD',
            contrastText: '#364C1D'
        },
        secondary: {
            main: '#C6DBE6',
            contrastText: '#35454C'
        },
        background: {
            default: '#121212'
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#CCCCCC'
        },
        cardIcon: {
            main: '#002FAD'
        },
        chart: {
            main: '#c4a6e6',
            min: '#E6A6A8',
            average: '#002FAD',
            max: '#A6E6E4'
        }

    }
})

export default DarkTheme